import { render, staticRenderFns } from "./ProviderContact.vue?vue&type=template&id=71ee2c73"
import script from "./ProviderContact.vue?vue&type=script&lang=js"
export * from "./ProviderContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports